import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import StudentPhotosActions, { StudentPhotosRedux, StudentPhotosTypes } from '../../Redux/ParentPlatform/PhotosRedux'

const studentPhotosCrudObservable = createCRUDObservable({
  mainRedux: StudentPhotosRedux,
  reduxPath: 'student_photos',
  dataHandlers: {
    get: response => response.data,
  },
})

const getStudentPhotosEpic = (action$, store, { Api }) => (
  action$.ofType(StudentPhotosTypes.getStudentPhotosRequest)
    .mergeMap(({ params }) => (
      Observable
        .fromPromise(Api.student_photos.getPhotos(params)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [StudentPhotosActions.getStudentPhotosError(response.error)]
          }

          return [StudentPhotosActions.getStudentPhotosSuccess(response)]
        })
    ))
)

export const StudentPhotosObservers = Object.assign({}, studentPhotosCrudObservable.observers, {})

export const StudentPhotosEpic = combineEpics(
  studentPhotosCrudObservable.epic,
  getStudentPhotosEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ParentPlatform/PhotosObservable.js